import React from 'react';
import './TonightPanel.css';
import { saveTonightSession, resetSession } from '../services/api';

function TonightPanel({ players, tonightPlayerIds, onSessionUpdate }) {
  // Compute tonight players by filtering players using tonightPlayerIds
  const tonightPlayers = players.filter(p => tonightPlayerIds.includes(p.id));

  // Handle removing a player from tonight
  const handleRemoveFromTonight = async (playerId) => {
    const newTonightIds = tonightPlayerIds.filter(id => id !== playerId);
    
    try {
      await saveTonightSession(newTonightIds);
      await onSessionUpdate();
    } catch (err) {
      console.error('Error removing player from tonight:', err);
      await onSessionUpdate();
    }
  };

  // Handle resetting tonight
  const handleReset = async () => {
    if (!window.confirm('Reset tonight\'s session? This will clear all selected players.')) {
      return;
    }

    try {
      await resetSession();
      await onSessionUpdate();
    } catch (err) {
      console.error('Error resetting session:', err);
      await onSessionUpdate();
    }
  };

  return (
    <div className="tonight-panel">
      <div className="panel-header">
        <h2>Tonight's Players</h2>
        {tonightPlayerIds.length > 0 && (
          <button
            className="btn btn-reset"
            onClick={handleReset}
          >
            Reset Tonight
          </button>
        )}
      </div>

      {tonightPlayers.length === 0 ? (
        <div className="empty-message">
          <p>No players selected for tonight. Use "Add to Tonight" in the Players section to select players.</p>
        </div>
      ) : (
        <>
          <div className="tonight-list">
            {tonightPlayers.map((player) => (
              <div key={player.id} className="tonight-player-item">
                <span className="player-name">{player.name}</span>
                <button
                  className="btn btn-small btn-remove"
                  onClick={() => handleRemoveFromTonight(player.id)}
                  title="Remove from Tonight"
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
          <div className="tonight-summary">
            <strong>{tonightPlayers.length}</strong> player{tonightPlayers.length !== 1 ? 's' : ''} selected for tonight
          </div>
        </>
      )}
    </div>
  );
}

export default TonightPanel;
